'use client';
import { jsx } from 'react/jsx-runtime';
import { useDeprecatedProps } from '../../hooks/use-deprecated-props.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

function _object_without_properties(e, o) {
    if (null == e) return {};
    var t, r, n = _object_without_properties_loose(e, o);
    if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(e);
        for(r = 0; r < a.length; r++)t = a[r], !(o.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (n[t] = e[t]);
    }
    return n;
}
function _object_without_properties_loose(e, o) {
    if (null == e) return {};
    var t, r, n = {}, a = Object.keys(e);
    for(r = 0; r < a.length; r++)t = a[r], o.indexOf(t) >= 0 || (n[t] = e[t]);
    return n;
}
const Callout = renderWithRef('Callout', null, (t, n)=>{
    let { skin: a = 'info', border: s = 'standard', variant: i = 'standard', emphasis: d = 'standard', size: p = 'standard', children: l } = t, c = _object_without_properties(t, [
        "skin",
        "border",
        "variant",
        "emphasis",
        "size",
        "children"
    ]);
    useDeprecatedProps('Callout', t, [
        {
            propName: 'border',
            instructions: 'The `border` prop is no longer being supported.'
        },
        {
            propName: 'variant',
            deprecatedValues: {
                standard: "The `variant` prop is no longer supported. Remove it's usage.",
                overlay: 'The `variant` prop is no longer supported. Use `emphasis=low` in place of `variant="overlay"`.',
                inverse: "The `variant` prop is no longer supported. Remove it's usage."
            }
        },
        {
            propName: 'size',
            instructions: 'Sizing is now handled automatically by standardMode/compactMode'
        },
        {
            propName: 'skin',
            deprecatedValues: {
                discount: 'The skin "discount" is deprecated. Use skin="promo" instead.',
                standard: 'The skin "standard" is deprecated. Use skin="info" instead.',
                foil: 'The skin "foil" is deprecated without a replacement. Remove it\'s usage.',
                new: 'The skin "new" is deprecated. Use skin="accent" instead.',
                announcement: 'The skin "announcement" is deprecated. Use skin="accent" instead.'
            }
        }
    ]);
    let u = new Set([
        'swan-callout'
    ]);
    return 'standard' !== a && 'info' !== a && u.add(`swan-callout-skin-${a}`), 'none' === s && u.add('swan-callout-borderless'), 'overlay' === i && u.add('swan-callout-overlay'), 'inverse' === i && u.add('swan-callout-inverse'), 'low' === d && u.add('swan-callout-emphasis-low'), 'mini' === p && u.add('swan-callout-mini'), jsx(RenderComp, {
        root: "span",
        forwardedRef: n,
        classNames: u,
        props: c,
        children: l
    });
});

export { Callout };
